import React from 'react';

const WHATSAPP_URL = 'https://wa.me/33652593441?text=Bonjour%2C%20je%20souhaite%20un%20devis%20pour%20du%20b%C3%A9ton%20d%C3%A9coratif.';

const WhatsAppButton = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Contactez-nous sur WhatsApp"
      className="fixed bottom-6 right-6 z-[9998] w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-200 group"
    >
      <svg viewBox="0 0 32 32" className="w-8 h-8 fill-white">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.502 1.128 6.746 3.046 9.386L1.054 31.37l6.18-1.964A15.9 15.9 0 0016.004 32C24.826 32 32 24.826 32 16.004S24.826 0 16.004 0zm9.32 22.608c-.39 1.1-1.932 2.014-3.166 2.28-.846.18-1.95.324-5.67-1.218-4.762-1.972-7.826-6.812-8.064-7.128-.23-.316-1.932-2.572-1.932-4.904s1.224-3.478 1.658-3.956c.434-.478.948-.598 1.264-.598.316 0 .632.002.906.016.292.016.682-.11 1.066.814.39.948 1.33 3.244 1.448 3.48.118.236.196.51.038.826-.158.316-.236.512-.472.79-.236.276-.496.618-.71.828-.236.236-.482.49-.206.962.276.472 1.226 2.022 2.632 3.276 1.81 1.614 3.336 2.114 3.808 2.35.472.236.748.196 1.024-.118.276-.316 1.184-1.382 1.5-1.856.316-.478.632-.394 1.066-.236.434.158 2.73 1.288 3.2 1.524.472.236.786.354.904.55.118.196.118 1.128-.274 2.228z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
